import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';
import { Scrollbars } from 'react-custom-scrollbars';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100% - 8.5em);

  .content-ct {
    width: calc(100% - 2em);
    margin-right: 2em;
    display: flex;
    flex-wrap: wrap;
  }
`;

export const ThisCard = styled(Card)`
  margin-bottom: 1.3em;
  border-radius: 1em;
  padding: 0.8em;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: calc((100% / 4) - 1em);
  height: 5em;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0px 20px rgba(174, 177, 200, 0.05);
  background: ${Colors.Color1};
  margin-left: 1.2em;

  :nth-child(4n+1) {
    margin-left: 0em;
  }
  

  ${props => {
    if (props?.ativo) {
      return `border: 0.1em solid ${Colors.Color8};`;
    }
  }}

  .card-bottom {
    margin-top: 0em;
    margin-left: 0.8em;
    width: 100%;
    display: flex;
    flex-direction: row
    justify-content: center
    align-items: flex-start;

    .card-grupo {
      background: ${Colors.Color8};
      border-radius: 0.4em;
      padding: 0.2em 0.6em;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 1em;
      margin-right: 1em;

      .grupoperfil {
        font-size: 0.7em;
        font-weight: bold;
        color: ${Colors.Color4};
      }
    }
  }

  .card-numero {
    position: absolute;
    bottom: -0.5em;
    right: -1.5em;
    width: 4.5em;
    height: 4.5em;
    padding: 0.5em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: ${Colors.Color8};
    border-radius: 5em;

    img {
      width: 2.5em;
      margin-bottom: 0.4em;
      margin-right: 1em;
    }
  }
}


  .card-body {
    margin-left: 0.8em;
    margin-top: 0.4em;
    width: 100%;

    .solicitante {
      font-size: 0.8em;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      display: -webkit-box;
      overflow: hidden;
      font-weight: 800;
      color: ${Colors.Color4};
    }

    .cliente {
      font-size: 0.65em;
      font-weight: 500;
      color: ${Colors.Color14};
    }
  }
`;

export const ScrollOS = styled(Scrollbars)`
  width: calc(100%) !important;
`;